'use strict';

import Base from './Base';
import { mapOptions } from '../tools';

/**
 * Placeholder Object
 * @param elContainer
 * @constructor
 */
class MemoPlaceholder extends Base {
    /**
     * Construct.
     * @param elContainer
     */
    constructor(elContainer = document.querySelector('body'), options = {}) {
        super();

        this._defaultSettings = {
            namespace: 'input',
            selector: '.input',
        };
        this._customSettings = options;
        this._settings = mapOptions(this._defaultSettings, this._customSettings);
        this.elContainer = elContainer;

        const nlInputs = this.elContainer.querySelectorAll(this._settings.selector);

        if (nlInputs.length > 0) {
            nlInputs.forEach((el) => {
                const elCurrentContainer = el;
                const elCurrentInput = elCurrentContainer.querySelector('input,textarea');

                if (elCurrentInput) {
                    this._applyListenersToItem(elCurrentInput, elCurrentContainer);
                }
            });
        }
    }

    /**
     * Apply event listener to field.
     * @param input
     * @param inputContainer
     * @private
     */
    _applyListenersToItem(input, inputContainer) {
        input.addEventListener('animationstart', function(target) {
            switch (target.animationName) {
                case 'onAutoFillStart':
                    inputContainer.classList
                        .add(this.getNamespace('--placeholder'), this.getNamespace('--is-filled-out'));
                    break;
                case 'onAutoFillCancel':
                    break;
            }
        }, false);

        if (input.hasAttribute('placeholder') || input.value !== '') {
            inputContainer.classList.add(this.getNamespace('--placeholder'), this.getNamespace('--is-filled-out'));
        } else {
            inputContainer.classList.add(this.getNamespace('--is-empty'));
        }

        input.addEventListener('focus', () => {
            inputContainer.classList.add(this.getNamespace('--has-focus'));
        });

        input.addEventListener('focusout', () => {
            inputContainer.classList.remove(this.getNamespace('--has-focus'));
        });

        input.addEventListener('change', () => {
            if (
                input.value === ''
                && (input.getAttribute('placeholder') === null
                    || input.getAttribute('placeholder') === '')
            ) {
                inputContainer.classList.add(this.getNamespace('--is-empty'));
                inputContainer.classList.remove(this.getNamespace('--is-filled-out'));
            } else {
                inputContainer.classList.remove(this.getNamespace('--is-empty'));
                inputContainer.classList.add(this.getNamespace('--is-filled-out'));
            }
        });
    }
}

export default MemoPlaceholder;
